import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { RootState } from '../store'

export type IconType = "backgroundColor" | "outlineColor" | "image" | "text" | "video"

export interface ActiveToolState {
    itemId: string | null
    itemType: string | null
    iconType: IconType | null
}

const initialState: ActiveToolState = {
    itemId: null,
    itemType: null,
    iconType: null,
}

export const activeToolSlice = createSlice({
    name: 'activeTool',
    initialState,
    reducers: {
        setActiveTool: (state, action: PayloadAction<ActiveToolState>) => {
            state.itemId = action.payload.itemId
            state.itemType = action.payload.itemType
            state.iconType = action.payload.iconType
        },
        clearActiveTool: (state) => {
            state.itemId = null
            state.itemType = null
            state.iconType = null
        },
        toggleActiveTool: (state, action: PayloadAction<ActiveToolState>) => {
            if (state.itemId === action.payload.itemId && state.iconType === action.payload.iconType) {
                state.itemId = null
                state.itemType = null
                state.iconType = null
            } else {
                state.itemId = action.payload.itemId
                state.itemType = action.payload.itemType
                state.iconType = action.payload.iconType
            }
        },
    },
})

// ---------------- selectors ----------------
export const selectActiveTool = (state: RootState) => state.activeTool
export const isToolActive = (
    activeTool: ActiveToolState,
    iconType?: IconType | null,
    itemId?: string,
    itemType?: string
): boolean => {
    if (!iconType) return false; // if no iconType, treat as inactive

    const type = itemType?.toLowerCase();
    const activeType = activeTool.itemType?.toLowerCase();

    if (type === 'group') {
        return activeType === 'group' && activeTool.iconType === iconType;
    } else if (type === 'single') {
        return activeTool.itemId === itemId && activeTool.iconType === iconType;
    }

    return activeTool.itemId === itemId && activeTool.iconType === iconType;
};

// ---------------- export actions and reducer ----------------
export const { setActiveTool, clearActiveTool, toggleActiveTool } = activeToolSlice.actions
export default activeToolSlice.reducer
